import { OriginItem, RecursiveItemTraceabilityDTO } from './origin-items.types'

export const getItemDataRecursive = (
  data: RecursiveItemTraceabilityDTO,
): OriginItem => {
  const item = {
    id: data.id,
    nodeId: data.id,
    code: data.code,
    description: data.description,
    quantity: data.quantity,
    taxUnit: data.taxUnit,
    itemProviderRelation: {
      companyClientTaxId: data.client.taxId,
      companyProviderEmail: data.provider.email,
      companyProviderTaxId: data.provider.taxId,
      companyProviderName: data.provider.name,
      companyProviderSegment: data.provider.segment,
    },
    level: 0,
    type: data.type,
    originItems: data.originItems?.length
      ? data.originItems.map((oi) => getItemDataRecursive(oi))
      : [],
    referenceId: data.id,
  } as OriginItem

  if (data.invoice) {
    item.itemInvoice = {
      invoiceCode: data.invoice?.code,
      invoiceCreateDate: data.invoice?.createDate?.toString(),
    }
  }

  return item
}
